import { compose } from 'redux';

import type { MaintenanceState } from '../maintenanceStore';

const selectPastMaintenanceDomain = (state: MaintenanceState) => state.pastMaintenances;

export const selectPastMaintenances = compose((state) => state.pastMaintenancesMapsWebData, selectPastMaintenanceDomain);
